import React, { useEffect, useState,useRef } from "react";
import { Button, Modal, Form, Input, Select, InputNumber, Pagination, Switch, Tag ,Radio} from 'antd';
import { BreathAPIs } from "../../../APIs/BreathAPIs";
import styles from "./styles.module.css";
import { MinusCircleOutlined, PlusCircleOutlined, CloseOutlined } from "@ant-design/icons";
import { toast } from 'react-toastify';
const AddPermission = ({ isVisible, setShowAddNewPermissionModal, currentUserGroup, setUserGroupData, userGroupData, locations }) => {

  const [userPermissions, setUserPermissions] = useState([]);
  const [allUserPermissions, setAllUserPermissions] = useState([]);
  const [selectedPermissions, setSelectedPermissions] = useState(
    [...Object.entries(JSON.parse(currentUserGroup.permissions)).map(([key, value], index, entries) => { return {  permissionName: key, permissionSelectedValue: value } })]);
  const [locationSpecificPermissions, setLocationSpecificPermissions] = useState([]);
  const [customChildPermissionsCount, setCustomChildPermissionsCount] = useState([]);
  const [customChildPermissions, setCustomChildPermissions] = useState([]);
  const parentPermissionNameRef = useRef(null); 
  const parentPermissionTagColorRef = useRef(null); 
  const [permissionsToggle,setPermissionsToggle] = useState('Modify Permission(s)');
  // const [currentUserGroupPermissions,setCurrrentUserGroupPermissions] = useState(Object.entries(JSON.parse(currentUserGroup.permissions)))
  // console.log(currentUserGroupPermissions);
  // const [toggleFunction, setToggleFunction] = useState(true);

  // const [formValues, setFormValues] = useState({});
  // const [form] = Form.useForm();
  const [pagination, setPagination] = useState({
    total: 0,
    current: 1,
    pageSize: 5,
    totalPages: 0
  });

  // Handle page change
  const handlePageChange = (currentPage) => {

    // const {current,pageSize} = pagination;
    // console.log(current);
    // console.log(pageSize);
    fetchUserPermissions(currentPage, pagination.pageSize);
  };

  const handlePermissionIsLocationSpecificChange = (selectedPermission, checked) => {

    // if (parentPermissionType === 'existingParentPermission') {

      if (checked) {

        // Add child permission
      
        selectedPermissions.splice(selectedPermissions.findIndex((permission)=>permission.permissionName === selectedPermission) + 1 , 0 ,{ _id: `${selectedPermission}LocationSpecificChildPermission`,showDisplay:false ,permissionName: `${selectedPermission}Locations` ,permissionSelectedValue: [] }) 
        setSelectedPermissions([...selectedPermissions]);
        // setSelectedPermissions([
        //   ...selectedPermissions,
        //   { _id: `${selectedPermission}LocationSpecificChildPermission`, permissionName: `${selectedPermission}Locations`, permissionSelectedValue: [] },
        // ]);
      } else {

        // Remove already present location specific child permission
        // const foundLocationSpecificChildPermission = currentUserGroupPermissions.some(([permissionName])=>permissionName===`${selectedPermission}Locations`)
        // if(foundLocationSpecificChildPermission){
        //   console.log('found the permission: ',foundLocationSpecificChildPermission)
        //   const newUpdates = currentUserGroupPermissions.filter(([permissionName])=>permissionName!==`${selectedPermission}Locations`)
        //   setCurrrentUserGroupPermissions(newUpdates)
        // }
        // console.log('Inside location specific permission removal section')
        // console.log('selected permission: ', selectedPermission)

        // Remove child permission
        const finalUpdatedPermissions = selectedPermissions.filter(
          (permission) => permission.permissionName !== `${selectedPermission}Locations`
        );
        setSelectedPermissions(finalUpdatedPermissions);
      }

    //}
    // else {

    //   setUserPermissions((permissions) =>
    //     permissions.map((permission) =>
    //       permission.permissionName === selectedPermission.permissionName
    //         ? { ...permission, isLocationSpecific: checked }
    //         : permission
    //     )
    //   );

    //   const updatedPermissions = selectedPermissions.map((permission) =>
    //     permission._id === selectedPermission._id
    //       ? { ...permission, isLocationSpecific: checked }
    //       : permission
    //   );

    //   if (checked) {
    //     // Add child permission
    //     setSelectedPermissions([
    //       ...updatedPermissions,
    //       { permissionName: `${selectedPermission.permissionName}Locations`, permissionSelectedValue: [] },
    //     ]);
    //   } else {
    //     // Remove child permission
    //     const finalUpdatedPermissions = updatedPermissions.filter(
    //       (permission) => permission.permissionName !== `${selectedPermission.permissionName}Locations`
    //     );
    //     setSelectedPermissions(finalUpdatedPermissions);
    //   }
    // }
  };

  const handleLocationSpecificPermissions = (selectedPermissionName, selectedLocations) => {

    try {
      

        setSelectedPermissions((permissions) =>
          permissions.map((permission) =>
            permission.permissionName === `${selectedPermissionName}`
              ? { ...permission, permissionSelectedValue: selectedLocations }
              : permission
          )
        );

      
     
    } catch (error) {
      console.error(error.message);
    }


  }

  const handleCustomChildPermissionCreation = (selectedPermission) => {

    //if (parentPermissionType === 'existingParentPermission') {

      setCustomChildPermissionsCount((customChildPermissionsCount) => {

        const foundPermission = customChildPermissionsCount.some((parentPermission) => parentPermission.permissionName === selectedPermission)
        if (foundPermission) {
          // If permission exists, update child permissions count
          return customChildPermissionsCount.map((permission) =>
            permission.permissionName === selectedPermission ?
              { ...permission, count: permission.count + 1 }
              :
              permission
          );
        }
        else {
          // If permission doesn't exist
          return [...customChildPermissionsCount, { permissionName: selectedPermission, count: 1 }]
        }

      })

   // }
    // else {

    //   const isPermissionSelected = selectedPermissions.some((permission) => permission.permissionName === selectedPermission.permissionName);

    //   if (isPermissionSelected) {

    //     setCustomChildPermissionsCount((customChildPermissionsCount) => {

    //       const foundPermission = customChildPermissionsCount.some((parentPermission) => parentPermission.permissionName === selectedPermission.permissionName)
    //       if (foundPermission) {
    //         // If permission exists, update child permissions count
    //         return customChildPermissionsCount.map((permission) =>
    //           permission.permissionName === selectedPermission.permissionName ?
    //             { ...permission, count: permission.count + 1 }
    //             :
    //             permission
    //         );
    //       }
    //       else {
    //         // If permission doesn't exist
    //         return [...customChildPermissionsCount, { permissionName: selectedPermission.permissionName, count: 1 }]
    //       }

    //     })
    //   }
    //   else {
    //     toast.error(`Please select ${selectedPermission.permissionName} before adding its custom child permissions`)
    //   }
    // }

  }

  const createCustomChildPermission = (selectedPermissionId, eventData, customChildPermissionInputType) => {

    try {

      const foundCustomChildSelectedPermission = selectedPermissions.some((permission) => permission._id === selectedPermissionId);
      const parentPermissionName = selectedPermissionId.split('-')[0];
      // Modify child permissions after they've been added to selected permissions
      if (foundCustomChildSelectedPermission) {

        setSelectedPermissions((permissions) => {

          return permissions.map((permission) => {
            if (permission._id === selectedPermissionId) {

              if (customChildPermissionInputType === 'childPermissionName') {
                return { ...permission, permissionName: `${eventData}` }
              }
              else {
                return { ...permission, permissionSelectedValue: eventData }
              }

            }
            else {
              return permission
            }
          })

        })



      }
      else {
        setCustomChildPermissions((permissions) => {
          const permissionFound = permissions.some((permission) => permission._id === selectedPermissionId);
          if (permissionFound) {
            // Custom child permission exists    
            if (customChildPermissionInputType === 'childPermissionName') {
              return permissions.map((permission) =>
                permission._id === selectedPermissionId ? { ...permission, permissionName: `${eventData}` } : permission
              )
            }
            else {
              return permissions.map((permission) =>
                permission._id === selectedPermissionId ? { ...permission, permissionSelectedValue: eventData } : permission
              )
            }
          }
          else {
            // Permission doesn't exist, create the permission

            if (customChildPermissionInputType === 'childPermissionName') {

              return [...permissions, { _id: selectedPermissionId, permissionName: `${eventData}`, permissionSelectedValue: '' }]
            }
            else {
              return [...permissions, { _id: selectedPermissionId, permissionName: '', permissionSelectedValue: eventData }]

            }
          }

        })

      }
    } catch (error) {
      console.error(error.message)
    }


  }

  const updateCustomChildPermissions = (selectedPermissionId) => {
    const foundChildPermission = customChildPermissions.find((childPermission) => childPermission._id === selectedPermissionId) 
    if (foundChildPermission) {
      // Remove custom child permission from selected permissions 
      const foundPermission = selectedPermissions.find((permission) => (permission._id === foundChildPermission._id))
      if (foundPermission) {
        const parentPermissionName = selectedPermissionId.split('-')[0];
        // console.log('parent permission name: ',parentPermissionName);
        let updatedPermissions = selectedPermissions.filter((permission)=>permission._id!==foundPermission._id)
        let updatedCustomChildPermission = customChildPermissions.filter((permission)=>permission._id!==foundPermission._id)
        // updatedCustomChildPermission.forEach((permission, index) => {
        //   permission._id = `${parentPermissionName}-${index}`;
        // });
        //Update id as values for child permission are derived using map func. index values 
        let customCounter = 0;
        updatedCustomChildPermission.forEach((permission, index) => {
          if(permission._id.includes(parentPermissionName)){

            permission._id = `${parentPermissionName}-${customCounter}`;
            customCounter += 1;
          }
        });

        // console.log('updated permissions:',updatedPermissions)

        customCounter = 0;
        updatedPermissions.forEach((permission)=>{
          if(permission._id && permission._id.includes(parentPermissionName)){
            permission._id = `${parentPermissionName}-${customCounter}`;
            customCounter += 1;
          }
        })

        
        setSelectedPermissions(updatedPermissions);
        setCustomChildPermissions(updatedCustomChildPermission)

        // Remove child permission from display
        setCustomChildPermissionsCount((customChildPermissionsCount) => {
          return customChildPermissionsCount.map((permission) =>
            permission.permissionName === selectedPermissionId.split('-')[0] ? { ...permission, count: permission.count - 1 } : permission
          )
        })
      }
      else {
        const permissionNameCheck = selectedPermissionId.split('-')[0];
        
        // Check if child permission name is unique
        if (permissionNameCheck === foundChildPermission.permissionName || foundChildPermission.permissionName === ''  || selectedPermissions.find((permission)=>permission.permissionName === `${permissionNameCheck}${foundChildPermission.permissionName}`)) {
          toast.error(`Please enter a unique permission name `);
        }
        // Check if child permission has some value entry 
        else if (!(foundChildPermission.permissionSelectedValue.length > 0)) {
          toast.error(`Please enter a permission value`)
        }
        else {
          // Add the child permission to selected permissions
          setSelectedPermissions((prev) => {
            return [...prev, { _id: selectedPermissionId, permissionName: `${permissionNameCheck}${foundChildPermission.permissionName}`, showDisplay: false, permissionSelectedValue: foundChildPermission.permissionSelectedValue }]
          })
        }
      }


    }
    else {
      toast.error('Please enter child permission details')
    }
  }

  async function fetchAllUserPermissions() {
    try {
      // console.log(page);
      // console.log(pageSize);
      let userPermissionsData = await BreathAPIs.getAllUserPermissionsList()
      
      // console.log('Available permissions: ',availablePermissions);

      setAllUserPermissions(userPermissionsData.data.response.permissions);
     
    } catch (error) {
      console.error(error)
    }
  }  


  async function fetchUserPermissions(page = 1, pageSize = 5) {
    try {
      // console.log(page);
      let userPermissionsData = await BreathAPIs.getUserPermissionsList({userGroupId:currentUserGroup._id, page: page, limit: pageSize })
      // console.log('UserPermissions: ',userPermissionsData.data.response.permissions);
      // console.log("userGroupResponse", userGroupResponse)

      // const availablePermissions = userPermissionsData.data.response.permissions.filter(
      //   (permission) =>
      //     !Object.keys(JSON.parse(currentUserGroup.permissions)).includes(permission.permissionName)
      // );
      // console.log('Available permissions: ',availablePermissions);


    setSelectedPermissions(selectedPermissions.map((selectedPermission) => {
      const matchedPermission = userPermissionsData.data.response.permissions.find(
        (permission) => permission.permissionName === selectedPermission.permissionName
      );
    
      return matchedPermission
        ? { ...selectedPermission, allowChildPermissions: matchedPermission.allowChildPermissions }
        : { ...selectedPermission };
    }))

      setUserPermissions(userPermissionsData.data.response.permissions);
      // setAllUserPermissions(userPermissionsData.data.response.permissions);
      setPagination({
        total: userPermissionsData.data.response.pagination.total,
        current: userPermissionsData.data.response.pagination.current,
        pageSize: userPermissionsData.data.response.pagination.pageSize,
        totalPages: userPermissionsData.data.response.pagination.totalPages
      });
    } catch (error) {
      console.error(error)
    }
  }

  function updatePermissions(selectedPermissionName ,selectedValue ,existingPermissionUpdate) {
    // console.log(permission);
    // console.log("selected permissions: ", selectedPermissions);

    try {

      if (existingPermissionUpdate) {

       // selectedPermissions.some((permission) => permission.permissionName === selectedPermissionName) ? (
          //Update existing permission
          setSelectedPermissions((prev) =>
            prev.map((selectedPermission) =>
              selectedPermission.permissionName === selectedPermissionName
                ? { ...selectedPermission, permissionSelectedValue: selectedValue }
                : selectedPermission
            )
          )
      //  ) 
      //   :
      //     (
      //       // Add permission after first change 
      //       setSelectedPermissions((prev) => {
      //         return [...prev, { permissionName: selectedPermissionName, permissionSelectedValue: selectedValue }]
      //       })
      //     )

      }
      else {

        if (selectedPermissions.some((selectedPermission) => selectedPermission.permissionName === selectedPermissionName)) {

          // Remove the parent permission and child permission if it exists as well ; No child exists without parent
          setSelectedPermissions((selectedPermissions) => {
            return selectedPermissions.filter(
              (selectedPermission) =>
                !selectedPermission.permissionName.includes(selectedPermissionName)
            )
          })

          //Set Location Specific to False if parent permission is removed
          setUserPermissions((permissions) =>
            permissions.map((userpermission) =>
              userpermission.permissionName === selectedPermissionName
                ? { ...userpermission, isLocationSpecific: false }
                : userpermission
            )
          )

          // Remove custom child permission count if parent permission is removed 
          setCustomChildPermissionsCount((customChildPermissions) => {
            return customChildPermissions.filter((customChildPermission) =>
              customChildPermission.permissionName !== selectedPermissionName
            )
          })

          // Remove custom child permission if parent permission is removed 
          setCustomChildPermissions((customChildPermissions) => {
            return customChildPermissions.filter((customChildPermission) => !customChildPermission._id.includes(selectedPermissionName))
          })


        }
        else {

          // Add the permission
          (selectedValue && selectedValue.length > 0) ?
            (

              setSelectedPermissions((prev) => {
                return [...prev, { permissionName: selectedPermissionName,permissionSelectedValue: selectedValue }]
              })
            ) :
            (
              toast.error(`Select Permission Value for ${selectedPermissionName}`)
            )

        }


      }



    } catch (error) {
      console.log(error)
    }
  }


  function permissionSubmit() {


    if (selectedPermissions.length > 0) {


      const updatedUserGroup = userGroupData.map((userGroup) => {
        if (userGroup._id === currentUserGroup._id) {
          const updatedPermissions = {};
          selectedPermissions.forEach((permission) => {
            updatedPermissions[permission.permissionName] = permission.permissionSelectedValue
          }); 

          // Sorting the object keys alphabetically
          const sortedUpdatedPermissions = Object.keys(updatedPermissions)
          .sort() // Sort the keys alphabetically
          .reduce((acc, key) => {
            acc[key] = updatedPermissions[key]; // Rebuild the object in sorted order
            return acc;
          }, {});

          return {
            ...userGroup,
            permissions: JSON.stringify(sortedUpdatedPermissions),
          };
        }
        return userGroup;
      });

      setUserGroupData(updatedUserGroup);

    }


    setShowAddNewPermissionModal(!isVisible);
    setSelectedPermissions([]);
    setUserPermissions([]);
    setLocationSpecificPermissions([]);
    setCustomChildPermissionsCount([]);
    setCustomChildPermissions([]);
    
    // parentPermissionNameRef.current = null;
    // parentPermissionTagColorRef.current = null;
  }

  // const permissionTagsColor = (currentPermission) => {
   
  
  //   const permissionName = selectedPermissions.find(
  //     (parentPermission) =>
  //       currentPermission.permissionName.includes(parentPermission.permissionName) &&
  //       parentPermission.permissionName.length <= currentPermission.permissionName.length
  //   )?.permissionName;
  
  //   const colorCodes = ["magenta", "red", "volcano", "orange", "gold", "green", "lime", "geekblue", "purple"];
  
  //   if (!parentPermissionNameRef.current) {
  //     // Initial condition when parentPermissionName is null
  //     parentPermissionNameRef.current = permissionName;
  //     const tagColor = colorCodes[parseInt(Math.random() * colorCodes.length)];
  //     parentPermissionTagColorRef.current = tagColor;
  //     return tagColor;
  //   } else {
  //     if (permissionName === parentPermissionNameRef.current) {
  //       // If the permission matches the parentPermission
  //       return parentPermissionTagColorRef.current;
  //     } else {
  //       // Assign new values for new permission
  //       const tagColor = colorCodes[parseInt(Math.random() * colorCodes.length)];
  //       parentPermissionNameRef.current = permissionName;
  //       parentPermissionTagColorRef.current = tagColor;
  //       return tagColor;
  //     }
  //   }
  // };



  useEffect(() => {
    fetchUserPermissions();
    fetchAllUserPermissions();
  }, [])

  return (
    <Modal
      title="Add / Modify Permission(s)"
      open={isVisible}
      onCancel={() => {
        setShowAddNewPermissionModal(!isVisible);
        setSelectedPermissions([]);
        setUserPermissions([]);
        setLocationSpecificPermissions([]);
        setCustomChildPermissionsCount([]);
        setCustomChildPermissions([]);
        // parentPermissionNameRef.current = null;
        // parentPermissionTagColorRef.current = null;
      }}
      okText='Submit'
      onOk={() => { permissionSubmit() }}
    >
       <div style={{width:'100%',display:'flex',alignContent:'center',justifyContent:'center',margin:'1rem 0rem'}}>
   
        <Radio.Group block 
                  options={[
                              {
                                label: 'Modify Permission(s)',
                                value: 'Modify Permission(s)',
                              },
                              {
                                label: 'Add Permission(s)',
                                value: 'Add New Permission(s)',
                              },
                              
                            ]} 
              defaultValue = {permissionsToggle}
              onChange={(event)=>{setPermissionsToggle(event.target.value)}}
              optionType="button" />
          </div>
      <div>
        {permissionsToggle==='Modify Permission(s)'?
        <>
        {/* <h5>Modify Existing / Newly Added Permission(s)</h5> */}
        <div className={styles['permissionView']}>
          {
            currentUserGroup?.permissions?.length > 0 ?
            (
              selectedPermissions.map(
                (permission, index) => (
                  <>
                      {
                        (permission.showDisplay !== false)
                        &&
                        <>
                          <div key={index} className={styles['permissionTile']}>
                            <div>
                              <div style={{width:'auto' ,display: 'flex', justifyContent: 'space-between' }}>
                                <div style={{display: 'flex', justifyContent: 'space-between',flexDirection:'column'}}>
                                <h6>{permission.permissionName}</h6>
                                { // Make child permissions as Input field
                                      (!permission.permissionName.includes('Locations') && selectedPermissions.find((parentPermission) => permission.permissionName.includes(parentPermission.permissionName) && parentPermission.permissionName.length < permission.permissionName.length)) ?
                                        <Input
                                          style={{ minWidth: '10em', maxWidth: '15em' }}
                                          value={permission.permissionSelectedValue}
                                          onChange={(event) => {
                                            updatePermissions(permission.permissionName, event.target.value, true)
                                          }}
                                        />
                                        :
                                        <Select
                                          {...(permission.permissionName.includes('Locations') && { mode: "multiple" })} // Enables multi-select for 'Locations'
                                          style={{ minWidth: '10em', maxWidth: '15em' }}
                                          placeholder="Select Value"
                                          value={permission.permissionSelectedValue}
                                          showSearch
                                          options={
                                            !permission.permissionName.includes('Locations')?
                                            allUserPermissions.find((userPermission) => permission.permissionName === userPermission.permissionName)?.permissionValues
                                              ?.map((permissionValue) => ({
                                                label: permissionValue, // Label for the dropdown
                                                value: permissionValue // Corresponding value
                                              }))

                                            :

                                            // Case of location child permissions
                                            locations.map((location) => ({
                                              label: location.locationName,
                                              value: location._id

                                            }))

                                          }



                                          filterOption={(input, option) =>
                                            option.label.toLowerCase().includes(input.toLowerCase())
                                          }
                                          onChange={(selectedValues) => {
                                            // const permission = allUserPermissions.find((permission) => permission.permissionName === key)
                                            // permission.permissionSelectedValue = selectedValues; // Updates the selected values
                                            // console.log('selected values',selectedValues);
                                            // console.log('permission name',permission.permissionName);
                                            updatePermissions(permission.permissionName, selectedValues ,true)
                                          }}
                                        />
                                      }
                                </div>
                                <div style={{display: 'flex',flexDirection:'column'}}>

                                {
                                  (permission.permissionName.includes('Locations') || selectedPermissions.find((parentPermission) => permission.permissionName.includes(parentPermission.permissionName) && parentPermission.permissionName.length < permission.permissionName.length)) ?
                                    <Tag color="cyan">Child  Permission</Tag>
                                    :
                                    <Tag color="blue">Parent Permission</Tag>
                                }
                                <Tag color={'gold'} style={{marginTop:'0.5rem'}} >{selectedPermissions.find((parentPermission) => permission.permissionName.includes(parentPermission.permissionName) && parentPermission.permissionName.length <= permission.permissionName.length)?.permissionName}</Tag>
                                </div>
                              </div>

                              <>

                               
                                {
                                  // Check if location-specific child permission exists
                                  !permission.permissionName.includes('Locations')   && !selectedPermissions.find((parentPermission) => permission.permissionName.includes(parentPermission.permissionName) && (permission.permissionName.length > parentPermission.permissionName.length)) && (
                                    <div style={{ marginTop: '1rem' }}>
                                      {'Location Specific'}
                                      <Switch
                                        checked={selectedPermissions.some((tempPermission) => tempPermission.permissionName === `${permission.permissionName}Locations`)}
                                        style={{ margin: '0rem 1rem' }}
                                        onChange={(checked) => {
                                          handlePermissionIsLocationSpecificChange(permission.permissionName, checked);
                                        }}
                                      />
                                    </div>
                                  )
                                }

                                {


                                  !selectedPermissions.some(
                                    (selectedPermission) => (permission.permissionName !== selectedPermission.permissionName && permission.permissionName.startsWith(selectedPermission.permissionName))
                                  )  &&(
                                    <div >
                                      <Button style={{ width: '100%', marginTop: '1rem' }} onClick={() => { handleCustomChildPermissionCreation(permission.permissionName) }} color="default" variant='outlined'>Create Custom Child Permissions</Button>
                                    </div>
                                  )

                                }


                              </>


                            
                              </div>
                          </div>
                        
                          {
                            (selectedPermissions.some((selectedPermission) => selectedPermission._id === `${permission.permissionName}LocationSpecificChildPermission`))
                            &&
                            <section className={styles['permissionTileAdditional']}>
                                <div style={{width:'auto' ,display: 'flex', justifyContent: 'space-between' }}>
                              <div style={{ width: '100%' }}>
                                <h6>{`${permission.permissionName}Locations`}</h6>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  <div>

                                    <Select
                                      // disabled={true}
                                      value={
                                        selectedPermissions.find(
                                          (selectedPermission) => selectedPermission.permissionName === `${permission.permissionName}Locations`
                                        )?.permissionSelectedValue || [] // Use an empty array as a fallback
                                      }
                                      mode="multiple"
                                      showSearch
                                      style={{ minWidth: '10em', maxWidth: '15em' }}
                                      placeholder='Select Locations'
                                      options={locations.map((location) => ({
                                        label: `${location.locationName}`,
                                        value: `${location._id}`,
                                      }))}
                                      onChange={(selectedValues) => {
                                        // console.log('selected values ',selectedValues);
                                        // console.log('permission name',`${permission.permissionName}Locations`)
                                        handleLocationSpecificPermissions(`${permission.permissionName}Locations`, selectedValues);
                                      }}
                                      filterOption={(input, option) =>
                                        option.label.toLowerCase().includes(input.toLowerCase())
                                      }
                                    />
                                  </div>
                                </div>
                                  </div>
                                 <div style={{width:'auto' ,display: 'flex',flexDirection:'column' }}>
                                  <Tag color="cyan">Child  Permission</Tag>
                                  <Tag style={{marginTop:'0.5rem'}} color="gold">{selectedPermissions.find((parentPermission) => permission.permissionName.includes(parentPermission.permissionName) && parentPermission.permissionName.length <= permission.permissionName.length)?.permissionName}</Tag>
                                  </div>
                              </div>
                            </section>
                          }
                          {
                            Array.from({
                              length: customChildPermissionsCount.find((parentPermission) => parentPermission.permissionName === permission.permissionName)?.count || 0
                            }).map((_, index) => {
                              return (
                                <section className={styles['permissionTileAdditional']}>
                                  <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div>
                                   
                                    <h6>Child Permission Name</h6>
                                      <Input onChange={(event) => { createCustomChildPermission(`${permission.permissionName}-${index}`, event.target.value, 'childPermissionName') }} style={{ width: '95%', marginTop: '0.35rem', marginBottom: '0.5rem' }} placeholder="Enter Permission Name"
                                      disabled={selectedPermissions.find((selectedPermission)=>selectedPermission._id ===`${permission.permissionName}-${index}` )?.permissionName}
                                      value={selectedPermissions.some((selectedPermission)=>selectedPermission._id ===`${permission.permissionName}-${index}` )?selectedPermissions.find((selectedPermission)=>selectedPermission._id ===`${permission.permissionName}-${index}` ).permissionName : customChildPermissions.find((selectedPermission)=>selectedPermission._id ===`${permission.permissionName}-${index}` )?.permissionName }
                                      />
                                      <h6>Child Permission Values</h6>
                                      <Input onChange={(event) => { createCustomChildPermission(`${permission.permissionName}-${index}`, event.target.value, 'childPermissionValue') }} style={{ width: '95%', marginTop: '0.35rem', marginBottom: '0.5rem' }} placeholder="Enter Permission Value"
                                        disabled={selectedPermissions.find((selectedPermission)=>selectedPermission._id ===`${permission.permissionName}-${index}` )?.permissionName}
                                        value={selectedPermissions.some((selectedPermission)=>selectedPermission._id ===`${permission.permissionName}-${index}` )?selectedPermissions.find((selectedPermission)=>selectedPermission._id ===`${permission.permissionName}-${index}` ).permissionSelectedValue : customChildPermissions.find((selectedPermission)=>selectedPermission._id ===`${permission.permissionName}-${index}` )?.permissionSelectedValue }

                                      />
                                    </div>
                                    <div  >
                                      <div style={{width:'7.5rem',height:'40px', display:'flex',flexDirection:'column',alignItems:'flex-end'}} >
                                        <Tag style={{top:'-1.15rem'}} color="cyan">Child Permission</Tag>
                                        <Tag style={{top:'-0.65rem'}} color="gold">{permission.permissionName}</Tag>
                                      </div>
                                      <div style={{width:'7.5rem',height:'60px', display:'flex',flexDirection:'column',alignItems:'flex-end'}} >
                                      <Button
                                        // style={{left:'5.25rem'}}
                                        onClick={() => { updateCustomChildPermissions(`${permission.permissionName}-${index}`) }}
                                        className={selectedPermissions.find((selectedPermission) => selectedPermission._id === `${permission.permissionName}-${index}`) ? styles['removeButton'] : styles['addButton']}
                                        icon={selectedPermissions.find((selectedPermission) => selectedPermission._id === `${permission.permissionName}-${index}`) ? <MinusCircleOutlined /> : <PlusCircleOutlined />}
                                      />
                                      </div>
                                    </div>
                                  </div>
                                </section>
                              )

                            })

                          }
                        </>
                      }

                    </>
                  )
                )
              )
              :
              ('No User Permissions Available')

          }
        </div>
        </>
        :
        <>
        {/* <h5>Add New Permission(s)</h5> */}
        <div>
          <div className={styles['permissionView']}>
            {

              (

                userPermissions.length > 0 ?
                  (userPermissions.map((permission, index) => {
                    return (
                      <>
                        <section key={pagination.current} className={styles['permissionTile']}>
                          <div style={{ width: '100%' }}>
                          <div style={{width:'auto' ,display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h6>{permission.permissionName}</h6>
                            {
                              ( selectedPermissions.some((parentPermission) => permission.permissionName === (parentPermission.permissionName))) ?
                                <Tag color="green">Permission Added</Tag>
                                :
                                null
                            }
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <div>
                                <Select

                                  // {...(permission.permissionName.includes('Locations') && { mode: "multiple" })}
                                  value={selectedPermissions.find((selectedPermission)=>selectedPermission.permissionName === permission.permissionName)?.permissionSelectedValue || permission.permissionSelectedValue}
                                  disabled={selectedPermissions.some((selectedPermission)=>selectedPermission.permissionName === permission.permissionName)}                           
                                  showSearch
                                  style={{ minWidth: '10em', maxWidth: '15em' }}
                                  placeholder='Select Value'
                                  options={permission.permissionValues.map((permissionValue) => {
                                    const isLocationPermission = permission.permissionName.includes('Locations');
                                    const locationName = isLocationPermission
                                      ? locations.find((location) => location._id === permissionValue)?.locationName
                                      : permissionValue;

                                    return {
                                      label: isLocationPermission && locationName ? locationName : `${permissionValue}`,
                                      value: `${permissionValue}`,
                                    };
                                  })}
                                  onChange={(selectedValues) => {
                                    permission.permissionSelectedValue = selectedValues; // Use the selected values array
                                  }}
                                  filterOption={(input, option) =>
                                    option.label.toLowerCase().includes(input.toLowerCase())
                                  }
                                />
                              </div>
                              <div>
                                <Button
                                  onClick={() => { updatePermissions(permission.permissionName,permission.permissionSelectedValue,false) }}
                                  className={selectedPermissions.find((selectedPermission) => selectedPermission.permissionName === permission.permissionName) ? styles['removeButton'] : styles['addButton']}
                                  icon={selectedPermissions.find((selectedPermission) => selectedPermission.permissionName === permission.permissionName) ? <MinusCircleOutlined /> : <PlusCircleOutlined />}
                                />
                              </div>

                            </div>
                           

                          </div>


                        </section>
                       
                      
                      </>

                    )
                  }))

                  :
                  ('No User Permissions Available')
              )

            }

          </div>

          <Pagination
            current={pagination.current}
            pageSize={pagination.pageSize}
            total={pagination.total}
            onChange={handlePageChange}
            style={{ textAlign: "right", marginBottom: '2rem' }}
          />
        </div>
        
        </>
        
        }
        

      </div>
    </Modal>
  )
}

export default AddPermission